import { ContextCtrl } from "./context/context"
import { ContextDialogCtrl } from "./context/dialog"
import { createHelpDialog } from "./help/help-dialog"
import { LoginLinkCtrl } from "./link/link"
import { LoginCtrl } from "./login/login"
import { MainViewCtrl } from "./main"
import { MenuCtrl } from "./menu/menu"
import { ButtonCtrl } from "./notifications/button"
import { EventInfoService } from "./notifications/eventInfoService"
import { PopupCtrl } from "./notifications/popup"
import { ResetPwdCtrl1 } from "./resetpwd/reset1"
import { ResetPwdCtrl2 } from "./resetpwd/reset2"
import { SignupCtrl } from "./signup/signup"

/// <reference path="main.ts" />
/// <reference path="context/context.ts" />
/// <reference path="login/login.ts" />
/// <reference path="link/link.ts" />
/// <reference path="menu/menu.ts" />
/// <reference path="help/help-dialog.ts"/>

export function setupMain(module: ng.IModule) {

    module
        .directive("omniaMain", MainViewCtrl.create)
        .directive("omniaMainMenu", MenuCtrl.create)
        .directive("omniaMainLogin", LoginCtrl.create)
        .directive("omniaMainLoginLink", LoginLinkCtrl.create)
        .directive("omniaMainResetPwd1", ResetPwdCtrl1.create)
        .directive("omniaMainResetPwd2", ResetPwdCtrl2.create)
        .directive("omniaMainContext", ContextCtrl.create)
        .directive("omniaMainContextDialog", ContextDialogCtrl.create)
        .directive("omniaMainSignup", SignupCtrl.create)
        .directive("omniaHelpDialog", createHelpDialog)

        .directive("omniaNotificationsButton", ButtonCtrl.create)
        .directive("omniaNotificationsPopup", PopupCtrl.create)
        .service("OmniaEventInfo", EventInfoService)

}
